import React from "react"
import StickyButton from "./sticky-button"

const LinkToTop = () => {
  // Set the top cordinate to 0
  // make scrolling smooth
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    })
  }

  return (
    <StickyButton position="-bottom-right">
      <div className="c-link-to-top" onClick={scrollToTop} />
    </StickyButton>
  )
}

export default LinkToTop
